import { useEffect } from "react";

export interface ToastMessage {
  id: number;
  kind: "success" | "error" | "info";
  text: string;
}

interface Props {
  toast: ToastMessage | null;
  onClose: () => void;
}

export function Toast({ toast, onClose }: Props) {
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(onClose, toast.kind === "error" ? 5000 : 2500);
    return () => clearTimeout(t);
  }, [toast, onClose]);

  if (!toast) return null;

  const color =
    toast.kind === "success"
      ? "bg-primary text-primary-foreground"
      : toast.kind === "error"
        ? "bg-destructive text-destructive-foreground"
        : "bg-secondary text-secondary-foreground";

  return (
    <div className="fixed bottom-[max(env(safe-area-inset-bottom),1rem)] inset-x-4 z-40 flex justify-center pointer-events-none">
      <div
        className={`pointer-events-auto rounded-lg px-4 py-2 text-sm shadow-lg ${color}`}
        role="status"
      >
        {toast.text}
      </div>
    </div>
  );
}
